import { useMemo } from 'react';
import { ScreenReaderLabel } from '@core/accessibility/screenReader/ScreenReaderLabel';
import { ScreenReaderPause } from '@core/accessibility/screenReader/ScreenReaderPause';
import { useContextTranslation } from '@core/i18n';
import { CustomProductPriceStyleWrapper } from '@core/shopping/components/CustomFonts';
import { useProductUnitPrice } from '@core/shopping/hooks/useProductUnitPrice';
import { UNIT_PRICE_LABEL } from '@player/testIds';
import { Discount, OriginalPrice, OverflowWrapper, Price, PriceWrapper, } from './PriceLabel.styles';
/**
 *
 */
export const UnitPriceLabel = ({ unit, currency, fontSize, // num in px - Controls the font size of the price label (both price & original price), original price can be specifically set with the originalPriceFontSize prop
originalPriceFontSize, // num in px - In the case where we have a discounted price
gapBetweenPrices, modifierFn, }) => {
    const { unitPriceWithCurrency, unitOriginalPriceWithCurrency, unitPrice, unitOriginalPrice, } = useProductUnitPrice({
        unit,
        currency,
        modifierFn,
    });
    const discountPercent = useMemo(() => unitPrice && unitOriginalPrice
        ? Math.round((1 - unitPrice / unitOriginalPrice) * 100)
        : 0, [unitPrice, unitOriginalPrice]);
    const { t } = useContextTranslation();
    return (<>
      <OverflowWrapper>
        <CustomProductPriceStyleWrapper data-testid={UNIT_PRICE_LABEL} fontSize={fontSize}>
          {unitOriginalPriceWithCurrency ? (<PriceWrapper gap={gapBetweenPrices ?? 4}>
              <Price>
                <ScreenReaderLabel visibleText={unitPriceWithCurrency} srText={t('player:on sale for {{unitPriceWithCurrency}}', {
                unitPriceWithCurrency,
            })}/>
              </Price>
              <ScreenReaderPause />
              <OriginalPrice originalPriceFontSize={originalPriceFontSize}>
                <ScreenReaderLabel srText={t('player:original price was {{unitOriginalPriceWithCurrency}}', { unitOriginalPriceWithCurrency })} visibleText={unitOriginalPriceWithCurrency}/>
              </OriginalPrice>
              <ScreenReaderPause />
              <Discount>
                {`(${t('player:{{discountPercent}}% OFF', {
                discountPercent,
            })})`}
              </Discount>
            </PriceWrapper>) : unitPriceWithCurrency ? (unitPriceWithCurrency) : null}
        </CustomProductPriceStyleWrapper>
      </OverflowWrapper>
    </>);
};
